import { render, staticRenderFns } from "./AddWx.vue?vue&type=template&id=31b0f31a&scoped=true"
import script from "./AddWx.vue?vue&type=script&lang=js"
export * from "./AddWx.vue?vue&type=script&lang=js"
import style0 from "./AddWx.vue?vue&type=style&index=0&id=31b0f31a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b0f31a",
  null
  
)

export default component.exports